import { useQuery } from "@tanstack/react-query";

import UserService from "@/services/UserService";

import { useAuth } from "@/hooks/useAuth";

import { meKeys } from "@/constants/CQueryKeys";

import { TUserSettings } from "@/types";

/**
 * The person's own rhythm (`GET /me/settings`): the working days and
 * the hours a day is worth. It belongs to them, not to what they look
 * at, so every page reads the same row (docs/modele.md, phase 4).
 */
export const useUserSettings = () => {
	const { isAuthenticated } = useAuth();
	const query = useQuery({
		queryKey: meKeys.settings,
		queryFn: (): Promise<TUserSettings> => UserService.fetchSettings(),
		enabled: isAuthenticated,
		staleTime: 5 * 60 * 1000,
	});

	return { settings: query.data, isLoading: query.isLoading };
};
